/**
 * Shared rendering for the closed reason catalogues the server sends as Inertia
 * props (status reasons, cancel reasons, mitra assignment reasons).
 *
 * Only the `value` code is ever stored; the labels live in Ruby constants on
 * AppointmentDraft, which are the source of truth. These helpers just pick which
 * label to show.
 */
export interface ReasonOption {
	labelEn: string;
	labelId: string;
	value: string;
}

// The admin portal defaults to Indonesian, so an unset locale reads as "id".
export const isIdLocale = (lng?: string): boolean =>
	(lng || "id").toLowerCase().startsWith("id");

// Pick the label for a reason based on the active locale.
export const reasonLabel = (reason: ReasonOption, lng?: string): string =>
	isIdLocale(lng) ? reason.labelId : reason.labelEn;

/**
 * Resolve a stored code to its label. An unrecognised code falls back to the raw
 * code rather than blank, so a catalogue that has drifted from the stored data
 * shows something an admin can report instead of an empty cell.
 */
export const findReasonLabel = (
	reasons: ReasonOption[] | undefined,
	value: string | null | undefined,
	lng?: string,
): string | null => {
	if (!value) return null;
	const match = (reasons || []).find((reason) => reason.value === value);
	return match ? reasonLabel(match, lng) : value;
};
